<template>
  <div class="item-wrapper" :class="{'visited': item.visited}">
    <div class="item">
      <div class="item-title-form">
        <div class="venue-info">
          <b-button :href="mapLink()" target="_blank" :disabled="!item.lat || !item.lng" variant="info" class="directions-action">
            <img src="../assets/google-maps.svg" height="25px" width="25px">
          </b-button>
        </div>
        <div class="item-actions">
          <b-button-group>
            <b-button variant="info" @click.prevent="toggleVisited">
              <fa-icon icon="redo" v-if="item.visited"></fa-icon>
              <fa-icon icon="check" v-else></fa-icon>
            </b-button>
            <b-button @click.prevent="toggleEditing" variant="info" >
              <fa-icon icon="edit" v-if="!loading && !editing"></fa-icon>
              <fa-icon icon="save" v-if="!loading && editing"></fa-icon>
              <b-spinner small type="grow" label="Loading..." v-if="loading"/>
            </b-button>
            <b-button @click.prevent="showModal" variant="info">
              <fa-icon icon="trash"></fa-icon>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="venue-text" v-if="!editing">
        <div class="venue-title">
          {{item.name}}
        </div>
        <div class="venue-details">
          {{ item.address }}
          <div class="duration-container">{{ humanDuration }}</div>
        </div>
      </div>
      <div class="venue-edit-form" v-else>
        <b-form @submit.prevent="submitEdit">
          <b-input placeholder="New Name" v-model="item.name"/>
        </b-form>
      </div>
      <!-- Begin note stuff -->
      <div class="note-wrapper">
        <ul v-if="item.notes && item.notes.length > 0" class="venue-notes">
          <note v-for="(note, index) in item.notes" :key="index" :note="note" @deleteNote="deleteNote"/>
        </ul>
        <b-form @submit.prevent="submitNote">
          <b-input-group>
            <b-input-group-prepend>
              <b-btn variant="info">
                <fa-icon icon="plus"></fa-icon>
              </b-btn>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="note"></b-form-input>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <b-modal ref="confirmModal" hide-footer title="Are you sure?">
      <b-button class="mt-3" variant="outline-danger" block @click="deleteVenue">Delete</b-button>
      <b-button class="mt-3" variant="outline-info" block @click="hideModal">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  // TODO: Make the buttons take up the whole card on the right?
  // Maybe not if there's too many notes
  import Note from './Note.vue'
  import VenueService from '@/services/VenueService'
  import * as axios from 'axios';

  export default {
    name: 'item',
    props: {
      item: {
        type: Object,
        required: true,
      },
      latitude: {
        type: Number,
        required: false
      },
      longitude: {
        type: Number,
        required: false
      }
    },
    data: function() {
      return {
        editing: false,
        loading: false,
        note: "",
        distanceLoaded: true,
        duration: null
      }
    },
    components: {
      Note
    },
    watch: {
      latitude: function() {
        this.updateDuration();
      },
      longitude: function() {
        this.updateDuration();
      }
    },
    computed: {
      humanDuration: function() {
        if (!this.distanceLoaded) {
          return 'Loading...';
        } else {
          if (this.duration) {
            const minutes = (this.duration / 60).toFixed(1);
            return `🚶 ${minutes}mins`;
          } else {
            // Just be blank... something went wrong
            return 'Sorry';
          }
        }
      }
    },
    mounted() {
      this.updateDuration();
    },
    methods: {
      updateDuration() {
        if (this.latitude && this.longitude && this.item.lat && this.item.lng) {
          this.distanceLoaded = false;
          const coordinates = `${this.longitude},${this.latitude};${this.item.lng.toFixed(6)},${this.item.lat.toFixed(6)}`
          const mapboxApi=`https://api.mapbox.com/directions-matrix/v1/mapbox/walking/${coordinates}?access_token=${process.env.VUE_APP_MAPBOX_KEY}`;
          axios.get(mapboxApi)
            .then(
              resp => {
                if (resp.data.message) {
                  this.duration = null;
                } else {
                  const durationExists = resp.data && resp.data.durations && resp.data.durations.length > 0;
                  this.duration = durationExists ? resp.data.durations[0][1] : null;
                }
                this.distanceLoaded = true;
              },
              () => {
                this.duration = null;
                this.distanceLoaded = true;
              }
            )
            .catch(() => {
              this.duration = null;
              this.distanceLoaded = true;
            })
            .then(() => {
              this.distanceLoaded = true;
            });
        }
      },
      deleteNote(note) {
        this.item.notes = this.item.notes.filter(n => n !== note);
        this.loading = true;
        VenueService.updateVenue(this.item)
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          })
          .then(() => {
            this.loading = false;
          });
      },
      mapLink() {
        return `https://www.google.com/maps/dir/?api=1&travelmode=walking&destination=${this.item.name},${this.item.address}`
      },
      submitEdit() {
        this.loading = true;
        VenueService.updateVenue(this.item)
          .then(() => {
            this.toggleEditing();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          })
          .then(() => {
            this.loading = false;
          });
      },
      toggleVisited() {
        this.item.visited = !this.item.visited;
        this.item.visited_on = new Date();
        VenueService.updateVenue(this.item);
      },
      toggleEditing() {
        this.editing = !this.editing;
      },
      deleteVenue() {
        VenueService.deleteVenue(this.item);
      },
      submitNote() {
        if (this.note !== "") {
          this.item.notes.push(this.note);
          VenueService.updateVenue(this.item)
            .then(() => {
              this.note = "";
            });
        }
      },
      showModal() {
        this.$refs.confirmModal.show()
      },
      hideModal() {
        this.$refs.confirmModal.hide()
      }
    }
  }
</script>

<style lang="scss" scoped>

  .item-title-form {
    display: flex;
    justify-content: space-between;
  }
  .empty {
    padding: 0 0 10px 0;
    color: #aaa;
  }

  .venue-info {
    display: flex;
    align-items: center;
  }

  .venue-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 1.5em;
    font-weight: bolder;
    margin-bottom: 0.5rem;
  }
  .venue-details {
    font-size: 0.55em;
    color: rgba(0, 0, 0, .5);
  }

  .venue-edit-form {
    margin: 0.5rem 0 0.5rem 0;
  }

  .directions-action {
    margin-right: 10px;
    background-color: transparent;
    border: 0;
    &.btn-info:not(:disabled):not(.disabled):active,
    &.btn-info:not(:disabled):not(.disabled):hover {
      background-color: rgba(255, 255, 255, 0.45);
      border: 0;
    }

    &.btn-info.disabled {
      background-color: transparent;
      opacity: 0.4;
      border: 0;
    }
  }

  .item {
    background-color: rgba(255, 255, 255, 0.45);
    border-radius: 4px 4px 0 0;
    padding: 10px;
  }

  .item-wrapper {
    margin: 20px 0;
  }

  .actions {
    width: 100%;
    justify-content: center;
    &.btn-group > .btn:not(:first-child) {
      margin-left: 0;
      border-left: 2px solid rgba(255, 255, 255, 0.25);
    }
    .btn {
      background-color:rgba(255, 255, 255, 0.30);
      border-radius: 0 0 4px 4px;
      border: 1px rgba(255, 255, 255, 0.75);
      color: #fff;
    }

    .how-far {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .visited:not(.modal) {
    opacity: 0.4;
  }

  .venue-notes {
    padding-left: 0;
  }

</style>
